import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const SignupSection = () => {
  const { user } = useAuth();

  // Don't render the section at all if user is signed in
  if (user) {
    return null;
  }

  return (
    <section id="signup" className="py-20 bg-up247-50/50">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">Get Started Today</h2>
        <p className="text-lg text-gray-600 mb-8">
          Create your account now and get access to our platform.
        </p>
        
        <div className="max-w-md mx-auto">
          <div className="flex flex-col gap-4">
            <p className="text-gray-700 mb-2">Sign up now to get started:</p>
            <Link to="/sign-up">
              <Button className="w-full bg-up247-600 hover:bg-up247-700 text-white">
                Create Account
              </Button>
            </Link>
            <p className="mt-2 text-gray-600 text-sm">
              Already have an account? <Link to="/sign-in" className="text-up247-600 hover:underline">Sign in</Link>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignupSection;